import { createAction } from '@reduxjs/toolkit';
import type { CheckDownloadPriorityAction } from 'reactApp/modules/priorityDownload/priorityDownload.types';

const checkDownloadPriority = createAction<CheckDownloadPriorityAction>('priorityDownload/checkDownloadPriority');

export const DownloadPriorityActions = { checkDownloadPriority } as const;
